module.exports = __webpack_public_path__ + "static/media/fonselp.ffeb784f.png";